import Vue from 'vue'
import App from './App.vue'
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
import VueI18n from 'vue-i18n'
import { getStorage, getBrowserLang } from '@/utils/localStorage'
import '@morioh/v-lightbox/dist/lightbox.css';
import Lightbox from '@morioh/v-lightbox'

import router from './router'
import store from './store'
Vue.use(VueI18n)
Vue.config.productionTip = false

Vue.use(Antd);
Vue.use(Lightbox);

const lang = getStorage('defi_nav_lang') || getBrowserLang()

var locale = lang ? lang : 'zh';
console.log('locale', locale)

const i18n = new VueI18n({
    locale, // 语言标识
    messages: {
        'zh': require('@/lang/zh'),
        'en': require('@/lang/en')
    }
})

new Vue({
    router,
    i18n,
    store,
    render: h => h(App),
}).$mount('#app')